import { InteractionType } from "@/generatedApi/userUserInteractionLoggerApi";

/**
 * AIレベルの加点量を算出する（バックエンドの calculate_points と同一ルール）。
 * トースト表示用。減算は無く、戻り値は常に 0 以上。
 *
 * - 新規: 興味なし +1 / 行った +3 / 行きたい +5
 * - 行きたい→行った（saved→visited）: +20
 * - visited→saved、saved/visited→disliked などの遷移: 0
 *
 * ※ 表示専用のため加点ルールをフロントに複製している。バックエンドの
 *    ルールを変更した場合は本関数も同期させること。
 */
export const calculateAiLevelPoints = (
  interactionType: InteractionType,
  previousInteractionType?: InteractionType | null
): number => {
  // ボーナス: 行きたい→行った
  if (
    interactionType === InteractionType.VISITED &&
    previousInteractionType === InteractionType.SAVED
  ) {
    return 20;
  }
  // 遷移（行った→行きたい / 行きたい・行った→興味なし など）は 0
  if (
    previousInteractionType === InteractionType.SAVED ||
    previousInteractionType === InteractionType.VISITED
  ) {
    return 0;
  }
  // 新規アクション
  if (interactionType === InteractionType.DISLIKED) return 1;
  if (interactionType === InteractionType.VISITED) return 3;
  if (interactionType === InteractionType.SAVED) return 5;
  return 0;
};

/**
 * 加点がある場合にトースト末尾へ付与する「好み学習+N」表記を返す。
 * 加点が 0 のときは空文字（表記なし）。
 */
export const aiLevelPointSuffix = (points: number): string =>
  points > 0 ? ` 好み学習+${points}` : "";
